import { render, staticRenderFns } from "./batch_adjust.vue?vue&type=template&id=5a5456ca&scoped=true&"
import script from "./batch_adjust.vue?vue&type=script&lang=js&"
export * from "./batch_adjust.vue?vue&type=script&lang=js&"
import style0 from "./batch_adjust.vue?vue&type=style&index=0&id=5a5456ca&scoped=true&lang=css&"
import style1 from "./batch_adjust.vue?vue&type=style&index=1&id=5a5456ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5456ca",
  null
  
)

export default component.exports